var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box, Chip, Stack, Typography, useMediaQuery } from "@mui/material";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { FieldFailureReportsKeys } from "../services/entity";
import { fieldFailureReportsPagingAPI } from "../services/apiCalls";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import { SubmitionPopUp } from "./submitPopUp";
import InfiniteScroll from "../../../builderPackage/components/infiniteScroll/infiniteScroll";
import { ExpandLess, ExpandMore, MoreVert } from "@mui/icons-material";
import { systemColor } from "../../../theme/systemColor";
import { dateFormate } from "../../../utils/utils";
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import FieldFailureReportDetailsMobileView from "./fieldFailureReportDetailsView/FieldFailureReportDetailsMobileView";
import FieldFailureReportDetailsView from "./fieldFailureReportDetailsView/FieldFailureReportDetailsDesktopView";
var FieldFailureReportCatalog = function (props) {
    var _crud, _crud2;
    var navigate = useNavigate();
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var value = props.value;
    var crud = useAppSelector(function (state) { return state.crud; });
    var hasMore = !crud[FieldFailureReportsKeys.Paging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || "All")] || ((_crud = crud[FieldFailureReportsKeys.Paging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || "All")]) === null || _crud === void 0 || (_crud = _crud.data) === null || _crud === void 0 ? void 0 : _crud.length) < ((_crud2 = crud[FieldFailureReportsKeys.Paging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || "All")]) === null || _crud2 === void 0 ? void 0 : _crud2.count);
    var dispatch = useAppDispatch();
    var ActionItem = function (id, row) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, reportId, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    console.log(id);
                    _a = id;
                    switch (_a) {
                        case 'view': return [3 /*break*/, 1];
                        case 'edit': return [3 /*break*/, 6];
                        case 'submit': return [3 /*break*/, 7];
                    }
                    return [3 /*break*/, 9];
                case 1:
                    if (!lgMode) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: 'Drawer',
                            Component: FieldFailureReportDetailsView,
                            containerProps: {
                                PaperProps: {
                                    sx: {
                                        maxWidth: {
                                            sm: '90%',
                                            md: 750
                                        }
                                    }
                                },
                                anchor: 'right'
                            },
                            componentProps: {
                                data: row
                            }
                        }))];
                case 2:
                    _b = _c.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Drawer',
                        Component: FieldFailureReportDetailsMobileView,
                        containerProps: {
                            PaperProps: {
                                sx: {
                                    maxHeight: {
                                        sm: 400,
                                        md: 400
                                    },
                                    height: {
                                        sm: 400,
                                        md: 400
                                    }
                                }
                            },
                            anchor: 'bottom'
                        },
                        componentProps: {
                            data: row
                        }
                    }))];
                case 4:
                    _b = _c.sent();
                    _c.label = 5;
                case 5:
                    _b;
                    return [3 /*break*/, 10];
                case 6:
                    {
                        reportId = row === null || row === void 0 ? void 0 : row.id;
                        if (reportId) {
                            navigate("/fieldFailureReports/".concat(reportId));
                        }
                        return [3 /*break*/, 10];
                    }
                    _c.label = 7;
                case 7: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Dialog',
                        Component: SubmitionPopUp,
                        containerProps: {
                            maxWidth: 'xs'
                        },
                        componentProps: {
                            data: {
                                row: row
                            }
                        }
                    }))];
                case 8:
                    res = _c.sent();
                    return [3 /*break*/, 10];
                case 9:
                    console.warn("Unhandled action id:", id);
                    _c.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            onClick: function () { },
            contentProps: {
                spacing: 0.5
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: "space-between",
                    display: "flex",
                    alignItems: 'center',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 8,
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "DocumentName",
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium'
                                    },
                                    fontSize: 'base',
                                    fontWeight: 'medium',
                                    color: systemColor.black
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "DocumentDate",
                                    valueGetter: function (val, row) { return val !== null && val !== void 0 && val.DocumentDate ? "".concat(dateFormate(val === null || val === void 0 ? void 0 : val.DocumentDate)) : '-'; },
                                    columnSize: true,
                                    labelTypographyProps: {
                                        fontSize: 'base',
                                        fontWeight: 'medium',
                                        color: 'text.tertiary'
                                    },
                                    fontSize: 'sm',
                                    fontWeight: 'normal',
                                    color: systemColor.lightGrey
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 4,
                            justifyContent: 'flex-end',
                            spacing: 1,
                            elements: [{
                                    type: FormItemTypes.Chip,
                                    name: 'Status',
                                    variant: 'outlined',
                                    size: 'small',
                                    columnSize: 0,
                                    color: 'info',
                                    sx: {
                                        borderRadius: '6px'
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'More',
                                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                                    size: 'small',
                                    variant: 'text',
                                    color: 'secondary',
                                    sx: {
                                        p: '7px'
                                    },
                                    columnSize: 0,
                                    setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                        var action;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                        type: 'Menu',
                                                        containerProps: {
                                                            anchorEl: e.target.parentElement
                                                        },
                                                        Component: ActionMenuList,
                                                        componentProps: {
                                                            items: [{
                                                                    id: 'edit',
                                                                    children: "Edit"
                                                                }, {
                                                                    id: 'submit',
                                                                    children: "Submit"
                                                                }, {
                                                                    id: 'view',
                                                                    children: "View"
                                                                }, {
                                                                    id: 'print',
                                                                    children: "Print"
                                                                }, {
                                                                    id: 'download',
                                                                    children: "Download"
                                                                }, {
                                                                    id: 'share',
                                                                    children: "Share"
                                                                }]
                                                        }
                                                    }))];
                                                case 1:
                                                    action = _a.sent();
                                                    ActionItem(action.payload, state);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); }
                                }]
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: 'expamd',
                    sx: {
                        bgcolor: "secondary.50",
                        border: "none"
                    },
                    contentProps: {
                        spacing: 1,
                        p: 1,
                        rowSpacing: 0
                    },
                    containerProps: {
                        my: 0
                    },
                    elements: __spreadArray(__spreadArray([], [{
                            label: 'Part',
                            codeField: 'PartCode',
                            nameField: 'PartName'
                        }, {
                            label: 'Model',
                            codeField: 'ModelCode',
                            nameField: 'ModelName'
                        }, {
                            label: 'Defect',
                            codeField: 'DefectCode',
                            nameField: 'DefectDescription'
                        }].map(function (item) { return ({
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.codeField,
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.nameField,
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    }); }), true), [{
                            type: FormItemTypes.Accordian,
                            name: 'expanded',
                            value: false,
                            summaryProps: {
                                sx: {
                                    display: 'none'
                                }
                            },
                            summary: [],
                            detailPanelProps: {
                                spacing: 1
                            },
                            sx: {
                                bgcolor: 'background.secondary',
                                border: 'none'
                            },
                            columnSize: 12,
                            setFieldProps: function (state, currValue, field) {
                                return {
                                    type: this.type,
                                    elements: __spreadArray([], [{
                                            name: 'Branch',
                                            label: 'Branch : '
                                        }, {
                                            name: 'ChasisNumber',
                                            label: 'Chassis No: '
                                        }, {
                                            name: 'RepairType',
                                            label: 'Repair Type:'
                                        }, {
                                            name: 'Ageing',
                                            label: 'Ageing :'
                                        }, {
                                            name: 'Intensity',
                                            label: 'Intensity :'
                                        }, {
                                            name: 'Source',
                                            label: 'Source :'
                                        }, {
                                            name: 'Identification',
                                            label: 'Identification :'
                                        }].map(function (item) { return ({
                                        type: FormItemTypes.Typography,
                                        name: item.name,
                                        label: item.label,
                                        fontSize: 'sm',
                                        fontWeight: 'medium',
                                        columnSize: 12,
                                        labelTypographyProps: {
                                            mb: 0,
                                            noWrap: true,
                                            fontWeight: 'medium',
                                            fontSize: 'sm'
                                        },
                                        containerProps: {
                                            display: 'flex',
                                            direction: 'row',
                                            justifyContent: 'space-between'
                                        },
                                        valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.name]) || '-'; }
                                    }); }), true)
                                };
                            },
                            elements: []
                        }], false)
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0,
                                fontSize: 'sm'
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['Hide', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['View more', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        }];
    var pagingColumns = [{
            type: 'string',
            field: "DocumentName",
            headerName: "Document Name",
            width: 200
        }, {
            type: 'date',
            field: "DocumentDate",
            valueFormatter: function (params) { return dayjs(params).format("DD-MM-YYYY"); },
            headerName: "Document Date",
            width: 150
        }, {
            field: "Branch",
            headerName: "Branch",
            width: 250
        }, {
            field: "ChasisNumber",
            headerName: "Chassis No",
            width: 200
        }, {
            field: "PartName",
            headerName: "Part",
            width: 200,
            renderCell: function (params) {
                var _params$row$PartName, _params$row, _params$row$PartCode, _params$row2;
                var partName = (_params$row$PartName = (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.PartName) !== null && _params$row$PartName !== void 0 ? _params$row$PartName : ' ';
                var partCode = (_params$row$PartCode = (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.PartCode) !== null && _params$row$PartCode !== void 0 ? _params$row$PartCode : ' ';
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'left'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, partName), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, partCode));
            }
        }, {
            field: "modelName",
            headerName: "Model",
            width: 200,
            renderCell: function (params) {
                var _params$row$ModelName, _params$row3, _params$row$ModelCode, _params$row4;
                var ModelName = (_params$row$ModelName = (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ModelName) !== null && _params$row$ModelName !== void 0 ? _params$row$ModelName : ' ';
                var ModelCode = (_params$row$ModelCode = (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ModelCode) !== null && _params$row$ModelCode !== void 0 ? _params$row$ModelCode : ' ';
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'left'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, ModelName), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, ModelCode));
            }
        }, {
            field: "DefectDescription",
            headerName: "Defect",
            width: 250,
            renderCell: function (params) {
                var _params$row$DefectDes, _params$row5, _params$row$DefectCod, _params$row6;
                var DefectDescription = (_params$row$DefectDes = (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.DefectDescription) !== null && _params$row$DefectDes !== void 0 ? _params$row$DefectDes : ' ';
                var DefectCode = (_params$row$DefectCod = (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.DefectCode) !== null && _params$row$DefectCod !== void 0 ? _params$row$DefectCod : ' ';
                return /*#__PURE__*/ React.createElement(Box, {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'left'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    sx: {
                        fontSize: 12
                    }
                }, DefectDescription), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, DefectCode));
            }
        }, {
            field: "RepairType",
            headerName: "Repair Type",
            width: 150
        }, {
            field: "Ageing",
            headerName: "Ageing",
            width: 100
        }, {
            field: "Intensity",
            headerName: "Intensity",
            width: 150
        }, {
            field: "Source",
            headerName: "Source",
            width: 150
        }, {
            field: "Identification",
            headerName: "Identification",
            width: 200
        }, {
            field: "Status",
            headerName: "Status",
            width: 200,
            renderCell: function (prisma) {
                return /*#__PURE__*/ React.createElement(Chip, {
                    color: "info",
                    sx: {
                        borderRadius: 1,
                        px: 1,
                        fontWeight: "medium",
                        fontSize: 12
                    },
                    label: prisma.value
                });
            }
        }, {
            type: 'actions',
            field: "Actions",
            headerName: "",
            width: 50,
            getActions: function (_ref) {
                var row = _ref.row;
                return [{
                        id: 'edit',
                        children: "Edit",
                        disabled: (row === null || row === void 0 ? void 0 : row.IsSubmit) || (row === null || row === void 0 ? void 0 : row.status) === ""
                    }, {
                        id: 'submit',
                        children: "Submit",
                        disabled: row === null || row === void 0 ? void 0 : row.IsSubmit
                    }, {
                        id: 'view',
                        children: "View",
                        divider: true
                    }, {
                        id: 'print',
                        children: "Print"
                    }, {
                        id: 'download',
                        children: "Download PDF"
                    }, {
                        id: 'share',
                        children: "Share"
                    }].map(function (it) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    showInMenu: true,
                    id: it.id,
                    label: it.children,
                    divider: it.divider,
                    disabled: it.disabled,
                    onClick: function () { return ActionItem(it.id, row); }
                }); });
            }
        }];
    return lgMode ? /*#__PURE__*/ React.createElement(Stack, {
        minHeight: 100
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: FieldFailureReportsKeys.Paging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || 'All'),
        pagingAPIRequest: {
            DataRange: value === null || value === void 0 ? void 0 : value.DataRange,
            FromDate: value !== null && value !== void 0 && value.DataRange ? value === null || value === void 0 ? void 0 : value.FromDate : undefined,
            ToDate: value !== null && value !== void 0 && value.DataRange ? value === null || value === void 0 ? void 0 : value.ToDate : undefined,
            search: value === null || value === void 0 ? void 0 : value.search,
            status: (value === null || value === void 0 ? void 0 : value.SelectedButton) === "All" ? null : value === null || value === void 0 ? void 0 : value.SelectedButton
        },
        getPagingData: fieldFailureReportsPagingAPI,
        columns: pagingColumns,
        dataGridProps: {
            sx: {
                marginX: 3
            },
            disableColumnSelector: true,
            cellSelection: false,
            onCellClick: function (params) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(params.field === "DocumentName")) return [3 /*break*/, 2];
                            return [4 /*yield*/, dispatch(showSurface({
                                    type: 'Drawer',
                                    Component: FieldFailureReportDetailsView,
                                    containerProps: {
                                        PaperProps: {
                                            sx: {
                                                width: '50%'
                                            }
                                        },
                                        anchor: 'right'
                                    },
                                    componentProps: {
                                        data: params.row
                                    }
                                }))];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); },
            disableColumnPinning: false,
            initialState: {
                pinnedColumns: {
                    left: ["DocumentName"],
                    right: ["Status", 'Actions']
                },
                density: "standard"
            }
        }
    })) : /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiCall: fieldFailureReportsPagingAPI,
        apiKey: FieldFailureReportsKeys.Paging + ((value === null || value === void 0 ? void 0 : value.SelectedButton) || "All"),
        apiRequest: {
            DataRange: value === null || value === void 0 ? void 0 : value.DataRange,
            FromDate: value !== null && value !== void 0 && value.DataRange ? value === null || value === void 0 ? void 0 : value.FromDate : undefined,
            ToDate: value !== null && value !== void 0 && value.DataRange ? value === null || value === void 0 ? void 0 : value.ToDate : undefined,
            search: value === null || value === void 0 ? void 0 : value.search,
            status: (value === null || value === void 0 ? void 0 : value.SelectedButton) === "All" ? null : value === null || value === void 0 ? void 0 : value.SelectedButton
        },
        hasMore: hasMore,
        gridContainerProps: {
            spacing: 2,
            p: 2
        },
        gridItemProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4
        },
        elements: formData
    });
};
export default FieldFailureReportCatalog;
